module.exports = __webpack_public_path__ + "static/media/pilot.5ab83ac4.png";